import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value", "special-rule", "required"]

import { ref,onMounted } from 'vue'
  import EventBus from '@/composables/EventBus'
  import { useMethods } from "@/composables/methods";
  import type {setDependencyObj} from "@/types";

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    section: null,
    sectionId: null,
    prestige: null,
    infoText: null,
    type: null,
    name: null,
    index: null,
    dependency: null,
    required: { type: Boolean },
    specialRule: { type: Boolean }
  },
  emits: ["add-prestige", "add", "remove", "replace", "rules", "get-dependency", "set-dependency"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'add-prestige', prestigeAmount?: number, checked?: boolean, name?: string, title?: string, type?: string, rule?: {type:boolean, default: false}):void
    (e: 'add', sectionTitle: string,title:string, index:string ):void
    (e: 'remove', sectionTitle: string,title:string, index:string ):void
    (e: 'replace', sectionTitle: string,title:string, index:string ):void
    (e: 'rules', forId: string, value: string,state:any,section:string):void
    (e: 'get-dependency',forId: string, checked: boolean, state:any ):void
    (e: 'set-dependency', rules: any):void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title?: string,
    section?: string,
    sectionId?: string,
    prestige?: string,
    infoText?: string,
    type?: string,
    name?: string,
    index?: string,
    dependency?: string,
    required?: boolean,
    specialRule?: boolean
  }

  const { getId } = useMethods()

  

  

  // --- Data ---
  const state = ref<string>("")
  const visibility = ref<boolean>(true)
  const checked = ref<boolean>(false)
  const id = ref<string>("")
  const prestigeAmount = ref<number>(0)
  const controls = ref<string>("")
  const value = ref<string>("")
  const dependencyActions = ref<any>([])
  const dependencyRules = ref<any>([])
  const isActive = ref<boolean>(true)

  // --- Methods ---
  const addPrestige = () => {
    prestigeAmount.value = Number(props.prestige);
    emit('add-prestige', prestigeAmount.value, checked.value, props.name, props.title, props.type, props.specialRule)

    let obj = {
      sectionTitle: props.section,
      title: props.title,
      index: props.index
    };

    if (props.type !== 'radio') {
      if (checked.value === true) {
        EventBus.emit('add', obj);
      } else {
        EventBus.emit('remove', obj);
      }
    } else {
      EventBus.emit('replace', obj);
    }


    if (controls.value !== '') {

      if (props.type === 'radio') {
        let rules = {
          forId : controls.value,
          value : value.value,
          state:  dependencyActions.value[0].state,
          section: props.sectionId
        };
        EventBus.emit('get-section-dependency', rules);
      } else {

        let rules = {
          forId : controls.value,
          checked : checked.value,
          state:  dependencyActions.value[0].state
        };
        EventBus.emit('get-dependency', rules);
      }
    }
  }


  // --- Lifecycle ---
  onMounted(() => {
    id.value = getId(props.title!)+'_'+props.index;

    if (props.dependency && props.dependency !== '') {
      let source:string[] = props.dependency.split("|");

      let obj:setDependencyObj = {
        target: id.value,
        value: source[1],
        state: source[2],
        controller: getId(source[0])
      }

      if (obj.state === 'show') {
        visibility.value = false;
      }

      dependencyRules.value.push(obj);
      emit('set-dependency', dependencyRules.value);
    }


    EventBus.on('get-dependency', obj => {

      if ( obj.forId === id.value) {
        if (obj.checked.toString() === dependencyRules.value[0].value) {

          if (obj.state === 'show') {
            visibility.value = true;
          } else {
            visibility.value = false;
            checked.value = false;
            emit('add-prestige',  prestigeAmount.value, checked.value, props.name,props.title,value.value, props.specialRule);
          }
        } else {
          if (obj.state === 'hide') {
            visibility.value = true;
          } else {
            visibility.value = false;
            checked.value = false;
            emit('add-prestige',  prestigeAmount.value, checked.value, props.name,props.title,value.value, props.specialRule);

          }
        }

      }
    });

    EventBus.on('set-dependency', obj => {

      if ( obj[0].controller === id.value ) {
        controls.value = obj[0].target;
        dependencyActions.value.push({'state':obj[0].state,'value':obj[0].value})
      }
    });

    EventBus.on('update-radios', obj => {
      for (const id of obj) {
        const title:string = getId(id) + '_' + props.index;
        if (id.value === title) {
          document.getElementById(id.value).checked = true;
        }
      }
    });
  })

return (_ctx: any,_cache: any) => {
  return (visibility.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ selection: isActive.value, 'active': state.value === __props.title })
      }, [
        _createElementVNode("label", { for: id.value }, [
          _createElementVNode("input", {
            id: id.value,
            type: "radio",
            class: "radio",
            name: __props.name,
            value: __props.title,
            "special-rule": props.specialRule,
            required: __props.required,
            onChange: addPrestige
          }, null, 40, _hoisted_2),
          _createTextVNode(" " + _toDisplayString(__props.title), 1)
        ], 8, _hoisted_1),
        _renderSlot(_ctx.$slots, "default")
      ], 2))
    : _createCommentVNode("", true)
}
}

})